import {
  rdbV1PlayerProfileDetail,
  v1PeopleHeadlinesPaginatedDetail,
} from '@on3/api';
import { type IGenericPageProps } from '@on3/ui-lib/api/schema/custom-contracts';
import withAuthentication from '@on3/ui-lib/src/hocs/withAuthentication';
import withValidUrl from '@on3/ui-lib/src/hocs/withValidUrl';
import { getFulfilledValue, proxyApi } from '@on3/ui-lib/utils/api';
import { getIdFromParam } from '@on3/ui-lib/utils/url';
import {
  type IPlayerNewsPageProps,
  PlayerNews,
} from 'components/Db/Profile/PlayerNews/PlayerNewsPage';
import { PageWrapper } from 'components/Layouts/PageWrapper';
import type { GetServerSideProps } from 'next';

interface IPlayerNewsPage extends IPlayerNewsPageProps, IGenericPageProps {}

const PlayerNewsPage = ({
  recruitsArticles,
  basicInfo,
  ...props
}: IPlayerNewsPage) => {
  const title = `${basicInfo?.name} News`;
  const noIndex = recruitsArticles?.pagination?.count === 0;

  return (
    <PageWrapper {...props} noIndex={noIndex} title={title}>
      <PlayerNews basicInfo={basicInfo} recruitsArticles={recruitsArticles} />
    </PageWrapper>
  );
};

export const getServerSideProps: GetServerSideProps = async (ctx) => {
  const siteData = await withValidUrl.isValid(ctx);
  const userData = await withAuthentication.isAuth(ctx);

  if (!siteData) {
    return {
      notFound: true,
    };
  }

  const { id } = ctx.query as { id: string };
  const personKey = getIdFromParam(id);

  if (!personKey) {
    return {
      notFound: true,
    };
  }

  try {
    const { page = 1 } = ctx.query;
    const params = {
      page: page as number,
      key: +personKey,
    };
    const playerParams = { personKey: +personKey };

    const [basicInfo, recruitsArticles] = await Promise.allSettled([
      rdbV1PlayerProfileDetail(proxyApi, playerParams),
      v1PeopleHeadlinesPaginatedDetail(proxyApi, params),
    ]);

    const data = {
      pageType: 'database',
      siteData,
      userData: userData || {},
      basicInfo: getFulfilledValue(basicInfo),
      recruitsArticles: getFulfilledValue(recruitsArticles),
    };

    return { props: { ...data } };
  } catch (e) {
    return { props: [] };
  }
};

export default withValidUrl(PlayerNewsPage);
